module.exports = __webpack_public_path__ + "static/media/wrong-answer.053c011c.svg";